module.exports = __webpack_public_path__ + "img/regina_andrew_logo.6c92cd1.png";